export class ListBillingTransactionHistoryRequest {
    'cloudProvider';
    'timeFrame';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "timeFrame",
            "baseName": "timeFrame",
            "type": "TimeFrame",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBillingTransactionHistoryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
